/* istanbul ignore file */
/* to be enabled on new pred UI with integration tests */
import { AnnoUiColorItem, AnnoUiItem, AnnoUiLabelItem, AnnoUiRegionItem, AnnoUiTextItem } from './annotations';
import { UiColorItem, UiLabelItem, UiRegionItem, UiTextItem, TCfUiItem, UiImageItem } from './base';
import { PredUiColorItem, PredUiImageItem, PredUiItem, PredUiLabelItem, PredUiRegionItem, PredUiTextItem } from './predictions';

export type TUiItemKind = 'ANNO' | 'PRED';

// TODO: replace property checks with mst type-checking for guarantees
// (annotations have a tendency to be corrupt data sometimes)

/* Base Guards */
export function isUiRegionItem(item: TCfUiItem): item is UiRegionItem {
  return 'regionData' in item;
}

export function isUiLabelItem(item: TCfUiItem): item is UiLabelItem {
  // make sure we don't consider region with label as label-only item
  return !isUiRegionItem(item) && 'concept' in item;
}

export function isUiTextItem(item: TCfUiItem): item is UiTextItem {
  // make sure we don't consider region with label as label-only item
  return !isUiRegionItem(item) && 'text' in item;
}

export function isUiColorItem(item: TCfUiItem): item is UiColorItem {
  return 'color' in item;
}

export function isUiImageItem(item: TCfUiItem): item is UiImageItem {
  return 'image' in item;
}

/* Prediction Guards */
function hasCorrectPredictionData(item: TCfUiItem): boolean {
  // TODO: add mst type checking
  return 'prediction' in item;
}

export function pred_isUiImageItem(item: TCfUiItem): item is PredUiImageItem {
  return isUiImageItem(item) && hasCorrectPredictionData(item);
}

export function pred_isUiRegionItem(item: TCfUiItem): item is PredUiRegionItem {
  return isUiRegionItem(item) && hasCorrectPredictionData(item);
}

export function pred_isUiLabelItem(item: TCfUiItem): item is PredUiLabelItem {
  return isUiLabelItem(item) && hasCorrectPredictionData(item);
}

export function pred_isUiTextItem(item: TCfUiItem): item is PredUiTextItem {
  return isUiTextItem(item) && hasCorrectPredictionData(item);
}

export function pred_isUiColorItem(item: TCfUiItem): item is PredUiColorItem {
  return isUiColorItem(item) && hasCorrectPredictionData(item);
}

export function isPredUiItem(item: TCfUiItem): item is PredUiItem {
  return pred_isUiColorItem(item) || pred_isUiTextItem(item) || pred_isUiLabelItem(item) || pred_isUiRegionItem(item) || pred_isUiImageItem(item);
}

/* Annotation Guards */

function hasCorrectAnnotationData(item: TCfUiItem): boolean {
  // TODO: add mst type checking
  return 'annotation' in item;
}

export function anno_isUiRegionItem(item: TCfUiItem): item is AnnoUiRegionItem {
  return isUiRegionItem(item) && hasCorrectAnnotationData(item);
}

export function anno_isUiLabelItem(item: TCfUiItem): item is AnnoUiLabelItem {
  return isUiLabelItem(item) && hasCorrectAnnotationData(item);
}

export function anno_isUiTextItem(item: TCfUiItem): item is AnnoUiTextItem {
  return isUiTextItem(item) && hasCorrectAnnotationData(item);
}

export function anno_isUiColorItem(item: TCfUiItem): item is AnnoUiColorItem {
  return isUiColorItem(item) && hasCorrectAnnotationData(item);
}

export function isAnnoUiItem(item: TCfUiItem): item is AnnoUiItem {
  return anno_isUiColorItem(item) || anno_isUiTextItem(item) || anno_isUiLabelItem(item) || anno_isUiRegionItem(item);
}
